import { css } from 'lit';

export const styles = css`igc-button::part(base):hover{color:var(--button-color)}`;
